export enum EInteractEventTrackerAction {
  CHK_UNLOGGED_ACCESS_SUCCESS = 'store_chk_unlogged_access_success',
  CHK_UNLOGGED_ACCESS_FAILED = 'store_chk_unlogged_access_failed',
  CHK_LOGIN = 'store_chk_login',
  CHK_LOGIN_SUCCESS = 'store_chk_login_success',
  CHK_LOGIN_FAILED = 'store_chk_login_failed',
  CHK_REGISTER = 'store_chk_register',
  CHK_REGISTER_SUCCESS = 'store_chk_register_success',
  CHK_REGISTER_FAILED = 'store_chk_register_failed',
  CHK_LOGGED_ACCESS_SUCCESS = 'store_chk_logged_access_success',
  CHK_LOGGED_ACCESS_FAILED = 'store_chk_logged_access_failed',
  CHK_ELIGIBILITY_FALSE = 'store_chk_eligibility_false',
  CHK_SHOW_OFFER_RECOMMENDATION = 'store_chk_show_offer_recommendation',
  CHK_CLICKED_RECOMMENDATION_OFFER = 'store_chk_clicked_recommendation_offer',
  CHK_SHOW_RECOMMENDATION_LA = 'store_chk_show_recommendation_la',
  CHK_CLICKED_RECOMMENDATION_LA = 'store_chk_clicked_recommendation_la',
  CHK_RENEWAL_REDIRECT = 'store_chk_renewal_redirect',
  CHK_RENEWAL_REDIRECT_FAILED = 'store_chk_renewal_redirect_failed',
  CHK_ORDER = 'store_chk_order',
  CHK_ORDER_SUCCESS = 'store_chk_order_success',
  CHK_ORDER_PAYMENT_FAILED = 'store_chk_order_payment_failed',
  CHK_ORDER_SYSTEM_FAILED = 'store_chk_order_system_failed',
  CHK_LOGOUT = 'store_chk_logout',
  CHK_PASSWORD_RECOVERY = 'store_chk_password_recovery',
  CHK_PASSWORD_RECOVERY_SUCCESS = 'store_chk_password_recovery_success',
  CHK_PASSWORD_RECOVERY_FAILED = 'store_chk_password_recovery_failed',
  UPSELL_OFFER = 'store_upsell_offer',
  UPSELL_OFFER_DENIED = 'store_upsell_offer_denied',
  UPSELL_ORDER = 'store_upsell_order',
  UPSELL_ORDER_SUCCESS = 'store_upsell_order_success',
  UPSELL_ORDER_PAYMENT_FAILED = 'store_upsell_order_payment_failed',
  UPSELL_ORDER_SYSTEM_FAILED = 'store_upsell_order_system_failed',
  CHK_CUPOM_SHOW = 'store_chk_cupom_show',
  CHK_CUPOM_SUBMIT = 'store_chk_cupom_submit',
  CHK_CUPOM_SUCCESS = 'store_chk_cupom_success',
  CHK_CUPOM_FAILED = 'store_chk_cupom_failed',
}

export enum EInteractEventTrackerActionPlatform {
  web = 'web',
  ios = 'iOS',
  android = 'android',
}
